import axios from 'axios';

export default {
  install(Vue, options) {
    let pdv = window.location.pathname.includes('/event/natal-luz') || window.location.pathname.includes('totem') ? 31821 : 100
    let pos = window.location.pathname.includes('/event/natal-luz') || window.location.pathname.includes('totem') ? 4382 : 2294
    const instance = axios.create({
      baseURL: process.env.VUE_APP_SERVER,
      timeout: 60000,
      headers: {
        PDV: pdv,
        POS: pos,
      },
    });

    Vue.prototype.$axios = instance;
  },
};
